import {SET_USER, LOG_OUT, SET_LOADING, SET_ERROR, CHECKED_AUTH} from './types';

const initState = {
    user: null,
    isFetching: false,
    isError: null,
    isCheckedAuth: false,
};

export default function (state = initState, action) {
    switch (action.type) {
        case SET_USER:
            state = {
                ...state,
                isFetching: false,
                isError: null,
                user: action.user,
                isCheckedAuth: true,
            };
            break;
        case SET_ERROR:
            state = {
                ...state,
                isError: action.isError,
            };
            break;
        case SET_LOADING:
            state = {
                ...state,
                isFetching: action.isFetching,
            };
            break;
        case LOG_OUT:
            state = {
                ...initState
            };
            break;
        case CHECKED_AUTH:
            state = {
                ...state,
                isCheckedAuth: true,
            };
            break;
    }
    return state;
}
